<template>
  <div id="content" v-if="isManager">
    <section id="user">
      <div class="input_list">
        <ul>
          <li>
            <span>
              <label class="list_key">{{label.corpName}}</label>
              <label class="important">必須</label>
            </span>
            <input type="text" class="list_box" v-model="corpForm.corpName" maxlength="32"/>
            <label v-if="errors.corpName" class="error_text">{{errors.corpName}}</label>
          </li>
          <li>
            <span>
              <label class="list_key">{{label.corpBranchName}}</label>
            </span>
            <input type="text" class="list_box" v-model="corpForm.corpBranchName" maxlength="32"/>
            <label v-if="errors.corpBranchName" class="error_text">{{errors.corpBranchName}}</label>
          </li>
          <li>
            <span>
              <label class="list_key">{{label.email}}</label>
              <label class="important">必須</label>
              <label class="small_p">仮登録したアドレスと間違いがないかご確認ください。</label>
            </span>
            <input type="text" class="list_box" v-model.trim="corpForm.email" placeholder="****@domans.co.jp" v-bind:disabled="!isEdit" maxlength="128"/>
            <label v-if="errors.email" class="error_text">{{errors.email}}</label>
          </li>
          <li>
            <span>
              <label class="list_key">{{label.tel}}</label>
              <label class="small_p">（半角数値、ハイフン不要）</label>
              <label class="important">必須</label>
            </span>
            <input type="text" class="list_box" v-model.trim="corpForm.tel" @keypress="validateNumber" @input="corpForm.tel=inputRestNumber($event)" maxlength="16"/>
            <label v-if="errors.tel" class="error_text">{{errors.tel}}</label>
          </li>
          <li>
            <span>
              <label class="list_key">{{label.fax}}</label>
              <label class="small_p">（半角数値、ハイフン不要）</label>
            </span>
            <input type="text" class="list_box" v-model.trim="corpForm.fax" @keypress="validateNumber" @input="corpForm.fax=inputRestNumber($event)" maxlength="16"/>
            <label v-if="errors.fax" class="error_text">{{errors.fax}}</label>
          </li>
          <li>
            <span>
              <label class="list_key">{{label.postcd}}</label>
              <label class="small_p">（半角数値、ハイフン不要）</label>
              <label class="important">必須</label>
            </span>
            <input type="text" class="list_box" v-model.trim="corpForm.postcd" @keypress="validateNumber" @input="corpForm.postcd=inputRestNumber($event)" @blur="addressCompletion"  maxlength="7"/>
            <label v-if="errors.postcd" class="error_text">{{errors.postcd}}</label>
          </li>
          <li>
            <span>
              <label class="list_key">{{label.state}}</label>
              <label class="important">必須</label>
            </span>
            <span class="list_box">
              <input type="text" v-model="corpForm.state" placeholder="都道府県" maxlength="32"/>
              <input type="text" v-model="corpForm.city" placeholder="市区町村" maxlength="32"/>
            </span>
            <label v-if="errors.state" class="error_text">{{errors.state}}</label>
          </li>
          <li>
            <span>
              <label class="list_key">{{label.street}}</label>
              <label class="important">必須</label>
            </span>
            <input class="list_box" type="text" v-model="corpForm.street"  maxlength="32"/>
            <label v-if="errors.street" class="error_text">{{errors.street}}</label>
          </li>
          <li v-if="!isEdit">
            <span>
              <label class="list_key">{{label.inviteCode}}</label>
            </span>
            <input class="list_box" type="text" v-model.trim="corpForm.inviteCode"  maxlength="16"/>
            <label v-if="inviteErrMessage" class="error_text">{{inviteErrMessage}}</label>
          </li>
          <div v-if="Object.keys(errors).length > 0" class="error_text">入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。</div>
        </ul>
      </div>
    </section>
  </div>
</template>
<script>
import * as Check from '../../../utils/Check'
import * as FormUtil from '../../../utils/FormUtil'
import {CORP_TYPE, INFO_SRC} from '../../constants/TypeEc'
import UseRuleDetial from '../common/UseRuleDetial'

export default {
  name: 'UserInput',
  components: {
    'dd-user-rule-detial': UseRuleDetial
  },
  props: {
    isEdit: Boolean,
    corpForm: Object,
    isManager: {
      type: Boolean,
      default: false
    },
    inviteErrMessage: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      errors: {},
      label: {
        corpName: '会社名',
        corpBranchName: '支店名・営業所名',
        email: 'メールアドレス',
        tel: '電話番号',
        fax: 'FAX',
        postcd: '郵便番号',
        state: '住所',
        street: '以下住所',
        inviteCode: '招待コード'
      },
      isExistPostcd: false
    }
  },
  computed: {
    corpTypeList: function () {
      return Object.keys(CORP_TYPE)
        .map(e => CORP_TYPE[e])
    },
    infoSrcList: function () {
      return Object.keys(INFO_SRC)
        .map(e => INFO_SRC[e])
    }
  },
  methods: {
    confirm: function () {
      // エラーメッセージのクリア
      this.errors = {}

      // 入力チェック
      this.validateRequire()
      if (Object.keys(this.errors).length !== 0) {
        this.$forceUpdate()
        return false
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        this.$forceUpdate()
        return false
      }

      if (this.isExistPostcd === false) {
        this.errors['postcd'] = this.label.postcd + 'が間違っています'
        this.$forceUpdate()
        return false
      }

      return true
    },
    validateRequire: function () {
      if (!this.corpForm.corpName) {
        this.errors['corpName'] = this.label.corpName + 'は必須項目です。'
      }
      if (!this.corpForm.email) {
        this.errors['email'] = this.label.email + 'は必須項目です。'
      }
      if (!this.corpForm.tel) {
        this.errors['tel'] = this.label.tel + 'は必須項目です。'
      }
      if (!this.corpForm.postcd) {
        this.errors['postcd'] = this.label.postcd + 'は必須項目です。'
      }
      if (!this.corpForm.state || !this.corpForm.city) {
        this.errors['state'] = this.label.state + 'は必須項目です。'
      }
      if (!this.corpForm.street) {
        this.errors['street'] = this.label.street + 'は必須項目です。'
      }
    },
    validateFormat: function () {
      if (!Check.isMail(this.corpForm.email)) {
        this.errors['email'] = 'メールアドレスの形式ではありません。'
      }
      if (!Check.isTel(this.corpForm.tel)) {
        this.errors['tel'] = this.label.tel + 'は半角数値で入力してください。'
      }
      if (this.corpForm.fax) {
        if (this.corpForm.fax.length > 0 && !Check.isTel(this.corpForm.fax)) {
          this.errors['fax'] = this.label.fax + 'は半角数値で入力してください。'
        }
      }
      if (!Check.isPostCd(this.corpForm.postcd)) {
        this.errors['postcd'] = this.label.postcd + 'は半角数値で入力してください。'
      }
    },
    setErrorMessage: function (messages) {
      if (messages.email) {
        this.errors['email'] = messages.email
        this.$forceUpdate()
      }
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    },
    addressCompletion: function () {
      FormUtil.addressCompletion(this.corpForm.postcd, (address) => {
        this.$set(this.corpForm, 'state', address.state)
        this.$set(this.corpForm, 'city', address.city)
        this.$set(this.corpForm, 'street', address.street)
        if (this.corpForm.postcd.length > 0 && (!this.corpForm.state || !this.corpForm.city)) {
          this.isExistPostcd = false
        } else {
          this.isExistPostcd = true
        }
      })
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.isExistPostcd = FormUtil.isExistPostcd(this.corpForm.postcd)
    })
  },
  created () {
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/user/CorpInput.vue